//this is ES6 syntax, it's essentially equivalent to: var React = require('react')
import React from 'react';
import { reduxForm, Field } from 'redux-form'; // imported Field

//Controls
import Controls from 'utils/renderControl.js';

//Validation function
import validate from './validate';

class Education extends React.Component {
  constructor(props) {
    super(props);
  }

  //now this component is getting passed props from the AppContainer
  static propTypes = {
    config: React.PropTypes.object,
    location: React.PropTypes.object,
    onSubmit: React.PropTypes.func,
  };

  componentDidMount() {
    setTimeout(
      function () {
        if (this.props.location.query.validate) {
          const submitter = this.props.handleSubmit(this.props.onSubmit);
          submitter(); // submits
        }
      }.bind(this),
      100
    );
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <form id="education" onSubmit={handleSubmit}>
        <h2>Education</h2>
        {/************************
         * MOBILE - PREVIOUS/NEXT
         *************************/}
        <div className="actions-mobile clearfix visible-xs-block">
          <a
            disabled={submitting}
            className="prev"
            onClick={this.props.goToPrevious}
          >
            <i className="fa fa-chevron-left" aria-hidden="true"></i> Previous
          </a>
          <button type="submit" disabled={submitting} className="btn">
            Next <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>

        {/************************
         * DESKTOP - EDUCATION
         *************************/}
        <table className="table no-border">
          <tbody>
            <tr>
              <th></th>
              <th>
                <label>Name and Location of School</label>
              </th>
              <th>
                <label>Years Completed</label>
              </th>
              <th>
                <label>Degree</label>
              </th>
              <th>
                <label>Major/Course Type</label>
              </th>
            </tr>
            {['High School'].map((type) => {
              //Camel case the string so we can use it as a property
              let prop = type.replace(
                /(?:^\w|[A-Z]|\b\w|\s+)/g,
                function (match, index) {
                  if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
                  return index == 0 ? match.toLowerCase() : match.toUpperCase();
                }
              );

              return (
                <tr key={type}>
                  <td>
                    <label>{type}</label>
                  </td>
                  <td>
                    <Field
                      name={`${prop + 'Attended'}`}
                      type="text"
                      component="input"
                      placeholder={type + ' Name and Location'}
                      className="form-control"
                    />
                  </td>
                  <td>
                    <Field
                      name={`${prop + 'YearsComplete'}`}
                      type="number"
                      component="input"
                      placeholder="Yrs"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <Field
                      name={`${prop + 'Degree'}`}
                      type="text"
                      component="input"
                      placeholder="Degree"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <Field
                      name={`${prop + 'Major'}`}
                      type="text"
                      component="input"
                      placeholder="Major"
                      className="form-control"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="row other-ed">
          <Field
            name="otherEducation"
            type="text"
            component={Controls.input}
            wrapperClassName="col-sm-12"
            label="Please list any other education, training certificates, computer, or special skills you possess that are related to the job for which you are applying:"
            placeholder=" "
          />
        </div>

        {/************************
         * PREVIOUS/NEXT
         *************************/}
        <div className="actions">
          <button
            type="button"
            disabled={submitting}
            className="btn btn-default"
            onClick={this.props.goToPrevious}
          >
            Previous
          </button>
          <button
            type="submit"
            disabled={submitting}
            className="btn btn-primary"
          >
            Next
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'employment-application',
  destroyOnUnmount: false,
  validate,
})(Education);
